"use client";

import * as Sentry from "@sentry/nextjs";
import { ChevronRight } from "lucide-react";
import React, { useEffect } from "react";
import Link from "next/link";
import { Button } from "@components/ui/button";
import routes from "@features/routes";

export default function GlobalErrorPage({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <div className="m-auto flex h-screen w-full flex-col items-center justify-center gap-2">
      <h1 className="text-[7rem] leading-tight font-bold">500</h1>
      <span className="font-medium">Oops! Something went wrong :)</span>
      <p className="text-center text-muted-foreground">
        {" "}
        We apologize for the inconvenience. <br /> Please try again later.
      </p>
      <div className="mt-6 flex gap-4">
        <Button asChild size="lg">
          <Link href={routes.application.pages.home.path()}>
            <span className="text-nowrap">Return Home</span>
            <ChevronRight className="opacity-50" />
          </Link>
        </Button>
      </div>
    </div>
  );
}
